export const columnMinWidth = 60;
export const defaultPaginationLimit = 20;

/** If there is a need for horizontal empty space inside of a table,
 * for example when grouping columns we need first column to have left margin so emptySpaceColumnId column is added with some minWidth.  */
export const emptySpaceColumnId = 'empty_space';
